import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCustomTracking: false,
  trackingError: {
    Deep_Link: false,
    Tracking_Link: false,
    Impression_Link: false,
    VTA_Link: false,
  },
};

const trackingSlice = createSlice({
  name: 'conversionTracking',
  initialState: initialState,
  reducers: {
    changeIsCustomTracking: (state, action) => {
      state.isCustomTracking = action.payload;
    },
    trackingErrorUpdate: (state, action) => {
      const { fieldName, errorValue } = action.payload;
      state.trackingError[fieldName] = errorValue;
    },
    resetTrackingError: (state) => {
      for (const field in state.trackingError) {
        if (state.trackingError[field]) state.trackingError[field] = false;
      }
    },
  },
});

export const trackingActions = trackingSlice.actions;
export default trackingSlice.reducer;
